import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import CountdownBanner from "@/components/CountdownBanner";
import { SEO } from "@/components/SEO";

// Lazy load all below-the-fold components to improve TTI
const FeaturedProducts = lazy(() => import("@/components/FeaturedProducts"));
const Categories = lazy(() => import("@/components/Categories"));
const InstagramFeed = lazy(() => import("@/components/InstagramFeed"));
const Newsletter = lazy(() => import("@/components/Newsletter"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO url="/home" />
      <Header />
      <div className="fixed top-16 md:top-20 left-0 right-0 z-40">
        <CountdownBanner />
      </div>
      <main>
        <Hero />
        <Suspense fallback={<div className="h-96" />}>
          <FeaturedProducts />
        </Suspense>
        <Suspense fallback={<div className="h-96" />}>
          <Categories />
        </Suspense>
        <Suspense fallback={<div className="h-64" />}>
          <InstagramFeed />
        </Suspense>
        <Suspense fallback={<div className="h-48" />}>
          <Newsletter />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
